import React, { useState } from "react";
export const SusanMac = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleOverflow = () => {
    setIsExpanded(!isExpanded);
  };
  return (
    <div>
      {" "}
      <div
        className=""
        id="myModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="myModalLabel"
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body" style={{ height: "100%" }}>
              <div className="row">
                <div className="col-lg-4">
                  <img
                    className="profile-image"
                    src="/images/IMG_4883_CROP.jpg"
                    alt="Susan MacMurchy"
                    style={{ margin: "10px 0" }}
                  />
                </div>
                <div className="col-lg-8">
                  <div className="modal-title-container">
                    <h4 className="modal-title" style={{ marginTop: "0" }}>
                      Susan MacMurchy
                    </h4>
                    <p className="helvetica-nueue">
                      <strong>Founder/Chief Innovation Officer</strong>
                    </p>
                    <p style={{ paddingTop: "17px" }}>
                      <strong>
                        "A good day? Any day I can get into water over my head."
                      </strong>
                    </p>
                  </div>
                  <div className="modal-body-container">
                    <p>
                      In her role as branding and strategic consultant to Delos,
                      Ms. MacMurchy led a team of architects, interior
                      designers, researchers, art directors, graphic designers
                      and writers in the initial creation of the Delos brand and
                      business model.
                    </p>

                    <p>
                      Susan has a strong background in wellness and health
                      creation, including alternative medicine and healing
                      modalities. Her work in planetary/human sustainability and
                      wellness product design has consumed the better part of
                      the last seven years. Ms. MacMurchy was also on staff or
                      consultant to: TBWA/ Chiat/Day, Saatchi & Saatchi, Scali,
                      McCabe & Sloves, Ogilvy & Mather, She left her job as V.P.
                      Creative Director to create Big Blue Fish.
                    </p>
                    {isExpanded ? (
                      <p id="toggleSusan">
                        Susan also spent two years in the fight against AIDS as
                        Managing Director of the not-for-profit film company,
                        AIDSFILMS, where she authored the award winning film
                        Aids: Changing the Rules. She continues her
                        philanthropic work as a founding member of the board of
                        4Point4 Foundation and various other non-profit and “for
                        benefit” corporations.{" "}
                      </p>
                    ) : null}
                    <button
                      type="button"
                      className="bbf-inline-link"
                      onClick={toggleOverflow}
                    >
                      {isExpanded ? "...less" : "...more"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-default"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
